import { useMutation, useQueryClient } from 'react-query'
import { useSnackbar } from 'notistack'

import { scanService } from 'src/services/scan.service'
import { QUERY_KEYS } from 'src/constants'

export const usePushScanToBc = (invalidateQuery: boolean = false) => {
  const { enqueueSnackbar } = useSnackbar()
  const queryClient = useQueryClient()

  return useMutation(async (scanId: string) => scanService.pushScanToBc(scanId), {
    async onSuccess(data) {
      if (!data) return

      queryClient.invalidateQueries(QUERY_KEYS.SCANS_STATUS_COUNT)

      if (data.balanceMessage) {
        setTimeout(() => {
          enqueueSnackbar(data.balanceMessage, { variant: 'warning' })
        }, 1000)
      }

      if (invalidateQuery) {
        queryClient.invalidateQueries(QUERY_KEYS.SCANS)
      }
    },
  })
}
